// Firm pages reached by navigation (Submit → booking → confirmation → status): name the tab after the page and move
// focus to its heading, so screen readers announce the new page the way the intake steps do (IntakeFlow).
import { useEffect } from 'react';
import { useNavigationType } from 'react-router-dom';

const APP_TITLE = 'Upstream Portal';

/** `title` null while the page is still loading; the effect runs once the heading (`data-page-heading`) is rendered. */
export function usePageHeading(title: string | null) {
  const nav = useNavigationType();
  useEffect(() => {
    if (!title) return;
    document.title = `${title} · ${APP_TITLE}`;
    // Only a link or button inside the flow (PUSH) moves to the heading. A fresh load, Back (POP) and redirects
    // (REPLACE, e.g. the email-link token exchange in Entry) keep the browser's own focus and scroll.
    if (nav === 'PUSH') {
      try { window.scrollTo(0, 0); } catch { /* jsdom */ }
      document.querySelector<HTMLElement>('[data-page-heading]')?.focus({ preventScroll: true });
    }
    return () => { document.title = APP_TITLE; };
  }, [title]); // eslint-disable-line react-hooks/exhaustive-deps -- once per page, not on every navigation type change
}
